import {
  ABILITIES,
  PATHFINDER_SAVES,
  resolveAbilityId,
  resolveCatalogId,
} from "../catalogs/characterSystemCatalog";

class Characteristics {
  constructor(json) {
    const supplied = json.mainCharacteristicList ?? [];
    this.mainCharacteristicList = ABILITIES.map((ability) => {
      const existing = supplied.find(
        (item) => resolveAbilityId(item.abilityId || item.name) === ability.id
      );
      return new MainCharacteristic(
        existing ?? { abilityId: ability.id, modifier: 0, diceValue: 10 }
      );
    });
    this.hp = new HitPoints(json.hp);
    this.baseArmorClass = Number(json.baseArmorClass ?? json.armorClass) || 0;
    this.additionalArmorClassModifier =
      Number(json.additionalArmorClassModifier) || 0;
    this.armorClass = Number(json.armorClass) || 0;
    this.baseAttackModifier = Number(json.baseAttackModifier) || 0;
    this.manualBaseAttackModifier = Number.isFinite(Number(json.manualBaseAttackModifier))
      ? Number(json.manualBaseAttackModifier)
      : this.baseAttackModifier;
    this.classBaseAttackBonus = Number(json.classBaseAttackBonus) || 0;
    this.combatManeuverSizeModifier =
      Number(json.combatManeuverSizeModifier) || 0;
    this.additionalCombatManeuverBonus =
      Number(json.additionalCombatManeuverBonus) || 0;
    this.additionalCombatManeuverDefense =
      Number(json.additionalCombatManeuverDefense) || 0;
    this.initiative = Number(json.initiative);
    this.walkingDistance = Number(json.walkingDistance);
    const suppliedSaves = json.pathfinderSaves ?? [];
    this.pathfinderSaves = PATHFINDER_SAVES.map((save) => {
      const existing = suppliedSaves.find(
        (item) =>
          resolveCatalogId(item.saveId || item.name, PATHFINDER_SAVES) === save.id
      );
      return new PathfinderSave(
        existing ?? {
          saveId: save.id,
          abilityId: save.abilityId,
          modifier: 0,
          proficiencyBonus: 0,
          otherBonus: 0,
        }
      );
    });
  }
}

class MainCharacteristic {
  constructor(json) {
    this.abilityId = resolveAbilityId(json.abilityId || json.name);
    this.modifier = Number(json.modifier);
    this.diceValue = Number(json.diceValue);
    this.baseDiceValue = Number.isFinite(Number(json.baseDiceValue))
      ? Number(json.baseDiceValue)
      : this.diceValue;
    this.manualAdjustment = Number(json.manualAdjustment) || 0;
    this.racialAdjustment = Number(json.racialAdjustment ?? json.ruleAdjustment) || 0;
    this.ruleAdjustment = this.racialAdjustment;
  }
}

class HitPoints {
  constructor(json = {}) {
    this.currentHP = Number(json.currentHP ?? 0);
    this.maxHP = Number(json.maxHP ?? 0);
    this.additionalHP = Number(json.additionalHP ?? 0);
  }
}

class PathfinderSave {
  constructor(json) {
    this.saveId = resolveCatalogId(json.saveId || json.name, PATHFINDER_SAVES);
    const definition = PATHFINDER_SAVES.find((save) => save.id === this.saveId);
    this.abilityId = resolveAbilityId(
      json.abilityId || json.abilityName || definition?.abilityId
    );
    this.modifier = Number(json.modifier);
    this.manualModifier = Number.isFinite(Number(json.manualModifier))
      ? Number(json.manualModifier)
      : this.modifier;
    this.classBaseBonus = Number(json.classBaseBonus) || 0;
    this.racialBonus = Number(json.racialBonus) || 0;
    this.proficiencyBonus = Number(json.proficiencyBonus ?? 0);
    this.otherBonus = Number(json.otherBonus ?? 0);
  }
}

export default Characteristics;
